module.exports = __webpack_public_path__ + "static/AppleStoreIcon-f6382b44969a4d40d2965af58c358d04.png";